export class SecureConfigService {
    private static instance: SecureConfigService;

    private authTokenDev: string;
    private authTokenProd: string;


    private constructor() {
        this.authTokenDev = this.loadAuthTokenDev();
        this.authTokenProd = this.loadAuthTokenProd();
    }

    public static getInstance(): SecureConfigService {
        if (!this.instance) {
            this.instance = new SecureConfigService();
        }
        return this.instance;
    }

    public getAuthTokenProd(): string {
        return this.authTokenProd;
    }
    public getAuthTokenDev(): string {
        return this.authTokenDev;
    }

    private loadAuthTokenDev(): string {
        return "Basic UTZMaXFCcFA6VEs3XzdvUDU=";
    }

    private loadAuthTokenProd(): string {
        return "Basic UTZMaXFCcFA6alhHKng2Rk8=";
    }
}
